export const shadows = {
  dropdown:
    '0px 1px 10px rgba(0, 0, 0, 0.2), 0px 13px 19px rgba(0, 0, 0, 0.05), 0px 18px 50px rgba(0, 0, 0, 0.04)',
};

export type Shadows = typeof shadows;
